import {Checkbox, Input, Loader, t} from 'owc-react-lib-common';
import * as React from 'react';
import {useState} from 'react';
import {Button} from 'src/components/Button';
import {ButtonLink} from 'src/components/ButtonLink';
import {Form} from 'src/components/Form';
import {Row} from 'src/components/Row/Row';
import {View} from 'src/components/View';
import {useComponentDidMount} from 'src/hooks/useComponentDidMount';
import * as EventService from 'src/services/EventService';
import * as GroupService from 'src/services/GroupService';
import {IGroupDTO} from 'src/services/GroupService';
import {ITeamDTO} from 'src/services/TeamService';
import {IValidationParams, REQUIRED, useValidation} from "../../../../../hooks/useValidation";
import * as Team3x3Service from "../../../../../services/Team3x3Service";


export interface IFicticiousTeamCreation {
  teamData: ITeamDTO
  onCancel: (object?: any) => void;
  onSave: (object?: any) => void;
}

export const UpdateFicticiousTeam = ({teamData, onCancel, onSave}: IFicticiousTeamCreation) => {
  const form = React.useRef<any>({id: teamData.id, uuid: teamData.uuid, name: teamData.name});
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = React.useState<any>({});
  const {validateAll} = useValidation();
  const [errors, setErrors] = React.useState<any>({});

  useComponentDidMount(async () => {
    const [eventResponse, groupsResponse] = await Promise.all([
      EventService.findByUuid(teamData.eventUuid),
      GroupService.getByCategoryId(teamData.eventCategoryId)
    ]);

    const event = eventResponse.data;
    const groups = groupsResponse.data.filter((res: IGroupDTO) => !res.isKnockout);
    const referenceData = Team3x3Service.decodeFictitiousTeamReference(teamData.teamReference);

    setData({
      eventName: event.name,
      eventCategoryName: event.eventCategories.find((ec: any) => ec.id === teamData.eventCategoryId).name,
      referenceData: {
        ...referenceData,
        groupNames: getGroupNamesLabel(groups, referenceData)
      }
    });

    setLoading(false);
  });

  const getGroupNamesLabel = (groups: any[], referenceData: any) => {
    return groups
      .filter(g => referenceData.groupIds.includes(g.id))
      .map(g => g.name)
      .join(', ');
  };

  const setName = React.useCallback((value: string) => {
    form.current.name = value
  }, []);

  const validate = React.useCallback(() => {
    const formRequiredFields: IValidationParams[] = [
      {name: "name", type: REQUIRED}
    ];

    const validated = validateAll(form.current, formRequiredFields);
    setErrors(validated.errors);
    return !validated.hasErrors;
  }, [validateAll]);

  if (loading) {
    return (<Loader/>)
  }

  return (
    <Form containerStyle={{minHeight: 500}}>
      <Row>
        <Input
          label={t('admin.events.team.name')}
          defaultValue={form.current.name}
          onChange={setName}
          style={{marginBottom: 20}}
          error={errors.name}
          required
        />
      </Row>
      <Row>
        <Checkbox label={t('admin.events.team.bestof')}
                  value={data.referenceData?.bestOf != null}
                  disabled
        />
      </Row>
      <Row>
        <Input
          label={t('admin.events.team.event')}
          value={data.eventName}
          disabled
        />
        <Input
          label={t('admin.events.team.category')}
          value={data.eventCategoryName}
          disabled
        />
      </Row>

      <Row>
        <Input key={'group'}
               label={t('admin.events.team.group')}
               value={data.referenceData?.groupNames}
               disabled
        />
        {data.referenceData?.bestOf &&
            <Input key={'bestof'}
                   label={t('admin.events.team.bestof')}
                   value={data.referenceData?.bestOf}
                   disabled
            />
        }
        <Input key={'position'}
               label={t('admin.events.team.position')}
               value={data.referenceData?.position}
               disabled
        />
      </Row>

      <View flexDirection='row' justifyContent='flex-end' style={{gap: 10}}>
        <ButtonLink to={''} onPress={() => onCancel()} label={t('global.cancel')}/>
        <Button marginBottom={0} onPress={() => {
          if (!validate()) return;
          onSave(form.current);
        }} label={t('global.save')}/>
      </View>
    </Form>
  )
};

